module.exports = __webpack_public_path__ + "static/media/iphone_15.78a2d3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/iphone_15.png
// module id = 1135
// module chunks = 0